/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation, StringScalar, IntScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar, ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  uuid: string;
  url: string;
  typeUrl?: string;
  order?: number;
  validCheck?: ValidType;
}>;

export const UpdatePlaylistUrl = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar />} value={option.uuid} />;
  const $url = <Variable name="url" scalar={<StringScalar />} value={option.url} />;
  const $typeUrl = <Variable name="type_url" scalar={<StringScalar isNullable={true} />} value={option.typeUrl} />;
  const $order = <Variable name="order" scalar={<IntScalar isNullable={true} />} value={option.order} />;
  const $validCheck = <Variable name="valid_check" scalar={<ValidTypeScalar isNullable />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_PLAYLIST_URL">
      <SelectionSet
        name="updatePlaylist_url"
        alias="updatePlaylistUrl"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            url: $url,
            type_url: $typeUrl,
            exposure_order: $order,
            valid_check: $validCheck
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updatePlaylistUrl: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.playlist.request<Data>(query, variables);
};
